(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lmds-bedding-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lmds-bedding-size-guide')) {
    customElements.define(
      'lmds-bedding-size-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.piece = this.dataset.piece || 'duvet';
          this.labels = (this.dataset.sizes || '').split('|').map((s) => s.trim());
          this.mats = this.parse(this.labels.join('|'));
          this.dims = { duvet: this.parse(this.dataset.duvets), sheet: this.parse(this.dataset.sheets) };
          this.values = (this.dataset.values || '').split('|');
          this.size = parseInt(this.dataset.size, 10) || 0;
          this.selected = parseInt(this.dataset.selected, 10);
          this.drawn = false;
          this.active = null;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.shapes = {};
          this.querySelectorAll('[data-shape]').forEach((el) => {
            this.shapes[el.dataset.shape] = el;
          });
          this.stats = {};
          this.querySelectorAll('[data-stat]').forEach((el) => {
            this.stats[el.dataset.stat] = el;
          });
          this.current = this.target();
          this.render(this.current, true);
          this.classList.add('bdsg--reset', 'is-ready');
          void this.offsetWidth;
          this.classList.remove('bdsg--reset');

          this.addEventListener('click', (e) => {
            const pieceBtn = e.target.closest('[data-piece-btn]');
            if (pieceBtn) return this.setPiece(pieceBtn.dataset.pieceBtn);
            const row = e.target.closest('[data-row]');
            if (row) {
              const cell = e.target.closest('td[data-col]');
              if (cell) this.setPiece(cell.dataset.col);
              this.setSize(parseInt(row.dataset.row, 10));
              return;
            }
            const keyed = e.target.closest('[data-key]');
            if (keyed) this.setActive(keyed.dataset.key);
          });

          this.addEventListener('pointerover', (e) => {
            if (e.pointerType !== 'mouse') return;
            const el = e.target.closest('[data-key]');
            this.setActive(el ? el.dataset.key : null);
          });
          this.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse') this.setActive(null);
          });
          this.addEventListener('focusin', (e) => {
            const el = e.target.closest('[data-key]');
            if (el) this.setActive(el.dataset.key);
          });
          this.addEventListener('focusout', () => this.setActive(null));

          const apply = this.querySelector('[data-apply]');
          if (apply) apply.addEventListener('click', () => this.applyToProduct());
          this.updateApply();

          this.section = this.closest('.shopify-section');
          this.onVariant = (e) => this.syncFromVariant(e);
          if (this.section) this.section.addEventListener('variant:update', this.onVariant);

          this.onLink = (e) => {
            const link = e.target.closest('[data-lmds-size-link]');
            if (!link) return;
            e.preventDefault();
            this.reveal();
          };
          document.addEventListener('click', this.onLink);

          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > 0) {
                this.positionBand();
                if (!this.drawn) this.draw();
              } else if (!entry.isIntersecting) {
                const details = this.closest('details');
                if (details && !details.open) {
                  this.drawn = false;
                  this.classList.remove('is-drawn', 'is-placed');
                }
              }
            });
          });
          this.io.observe(this);

          this.ro = new ResizeObserver(() => this.positionBand());
          this.ro.observe(this);
        }

        disconnectedCallback() {
          if (this.section) this.section.removeEventListener('variant:update', this.onVariant);
          document.removeEventListener('click', this.onLink);
          if (this.io) this.io.disconnect();
          if (this.ro) this.ro.disconnect();
          cancelAnimationFrame(this.raf);
        }

        reveal() {
          const panel = this.closest('.lmds-tabs__track > *');
          if (panel && panel.id) {
            const tab = document.querySelector('[aria-controls="' + panel.id + '"]');
            if (tab && tab.getAttribute('aria-selected') !== 'true') tab.click();
            const more = panel.querySelector(':scope > .lmds-tabs__more');
            const content = panel.querySelector('.details-content');
            if (more && !more.hidden && content && !content.classList.contains('is-expanded')) more.click();
          }
          const details = this.closest('details');
          if (details && !details.open) details.open = true;
          requestAnimationFrame(() => {
            const offset = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
            const top = this.getBoundingClientRect().top + window.scrollY - offset - 24;
            window.scrollTo({ top: Math.max(0, top), behavior: this.reduced ? 'auto' : 'smooth' });
            if (this.drawn) this.draw();
          });
        }

        parse(list) {
          return (list || '').split('|').map((s) => {
            const p = s
              .toLowerCase()
              .replace(/cm/g, '')
              .replace(/×/g, 'x')
              .replace(/\s/g, '')
              .split('x')
              .map((n) => parseFloat(n.replace(',', '.')));
            return { w: p[0] || 0, l: p[1] || 0 };
          });
        }

        target() {
          const m = this.mats[this.size] || { w: 160, l: 200 };
          const d = this.dims[this.piece][this.size] || m;
          return { mw: m.w, ml: m.l, w: d.w, l: d.l, split: m.w >= 130 ? 1 : 0 };
        }

        draw() {
          this.drawn = true;
          if (this.reduced) {
            this.classList.add('is-drawn');
            return;
          }
          this.classList.add('bdsg--reset');
          this.classList.remove('is-drawn');
          void this.offsetWidth;
          this.classList.remove('bdsg--reset');
          requestAnimationFrame(() => this.classList.add('is-drawn'));
        }

        rect(x, y, w, h, r) {
          const f = (n) => Math.round(n * 10) / 10;
          r = Math.min(r, w / 2, h / 2);
          return (
            'M' + f(x + r) + ' ' + f(y) +
            'H' + f(x + w - r) +
            'Q' + f(x + w) + ' ' + f(y) + ' ' + f(x + w) + ' ' + f(y + r) +
            'V' + f(y + h - r) +
            'Q' + f(x + w) + ' ' + f(y + h) + ' ' + f(x + w - r) + ' ' + f(y + h) +
            'H' + f(x + r) +
            'Q' + f(x) + ' ' + f(y + h) + ' ' + f(x) + ' ' + f(y + h - r) +
            'V' + f(y + r) +
            'Q' + f(x) + ' ' + f(y) + ' ' + f(x + r) + ' ' + f(y) +
            'Z'
          );
        }

        set(key, d) {
          const el = this.shapes[key];
          if (el) el.setAttribute('d', d);
        }

        move(key, x, y) {
          const el = this.shapes[key];
          if (el) el.setAttribute('transform', 'translate(' + Math.round(x * 10) / 10 + ' ' + Math.round(y * 10) / 10 + ')');
        }

        format(n, exact) {
          if (!exact) return String(Math.round(n));
          return String(Math.round(n * 2) / 2).replace('.', ',');
        }

        render(g, exact) {
          const hw = g.w / 2;
          const hm = g.mw / 2;
          this.set('piece', this.rect(-hw, 0, g.w, g.l, 4));
          this.set('stitch', this.rect(-hw + 5, 5, g.w - 10, g.l - 10, 2));
          this.set('hem', 'M' + (-hw + 3) + ' 13H' + (hw - 3));
          this.set('mat', this.rect(-hm, 0, g.mw, g.ml, 6));
          this.set('board', this.rect(-hm - 6, -17, g.mw + 12, 9, 3));

          const one = Math.min(70, g.mw - 20);
          const two = Math.min(66, (g.mw - 24) / 2);
          const pw = one + (two - one) * g.split;
          const x1 = -pw / 2 + (-4 - pw + pw / 2) * g.split;
          const x2 = -pw / 2 + (4 + pw / 2) * g.split;
          this.set('p1', this.rect(x1, 10, pw, 34, 9));
          this.set('p2', this.rect(x2, 10, pw, 34, 9));
          this.move('label', 0, g.ml * 0.5 + 8);

          const wy = g.l + 16;
          this.set('width-line', 'M' + -hw + ' ' + wy + 'H' + hw);
          this.set('width-tick', 'M' + -hw + ' ' + (wy - 5) + 'V' + (wy + 5) + 'M' + hw + ' ' + (wy - 5) + 'V' + (wy + 5));
          this.move('width-badge', 0, wy);

          const lx = hw + 16;
          this.set('length-line', 'M' + lx + ' 0V' + g.l);
          this.set('length-tick', 'M' + (lx - 5) + ' 0H' + (lx + 5) + 'M' + (lx - 5) + ' ' + g.l + 'H' + (lx + 5));
          this.move('length-badge', lx, g.l / 2);

          const dy = g.ml * 0.72;
          this.set('drop-line', 'M' + -hw + ' ' + dy + 'H' + -hm);
          this.set('drop-tick', 'M' + -hw + ' ' + (dy - 5) + 'V' + (dy + 5) + 'M' + -hm + ' ' + (dy - 5) + 'V' + (dy + 5));
          this.move('drop-badge', -(hw + hm) / 2, dy - 15);

          if (this.stats.width) this.stats.width.textContent = this.format(g.w, exact);
          if (this.stats.length) this.stats.length.textContent = this.format(g.l, exact);
          if (this.stats.drop) this.stats.drop.textContent = this.format((g.w - g.mw) / 2, exact);
        }

        animateTo(next) {
          cancelAnimationFrame(this.raf);
          const from = Object.assign({}, this.current);
          if (this.reduced || !this.drawn) {
            this.current = next;
            this.render(next, true);
            return;
          }
          const start = performance.now();
          const duration = 850;
          const step = (now) => {
            const t = Math.min(1, (now - start) / duration);
            const e = 1 - Math.pow(1 - t, 4);
            const g = {};
            Object.keys(next).forEach((k) => {
              g[k] = from[k] + (next[k] - from[k]) * e;
            });
            this.current = g;
            this.render(g, t === 1);
            if (t < 1) this.raf = requestAnimationFrame(step);
          };
          this.raf = requestAnimationFrame(step);
        }

        setPiece(piece) {
          if (piece !== 'duvet' && piece !== 'sheet') return;
          if (piece === this.piece) return;
          this.piece = piece;
          this.dataset.piece = piece;
          this.querySelectorAll('[data-piece-btn]').forEach((btn) => {
            btn.setAttribute('aria-pressed', btn.dataset.pieceBtn === piece ? 'true' : 'false');
          });
          this.animateTo(this.target());
        }

        setSize(index) {
          if (isNaN(index) || index < 0 || index >= this.labels.length) return;
          if (index === this.size) return;
          this.size = index;
          this.dataset.size = index;
          this.querySelectorAll('[data-row]').forEach((row) => {
            const on = parseInt(row.dataset.row, 10) === index;
            row.classList.toggle('is-sel', on);
            const btn = row.querySelector('[data-size-index]');
            if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          const label = (this.dataset.bedWord || '') + ' ' + this.labels[index];
          this.querySelectorAll('[data-stage-size]').forEach((el) => {
            el.textContent = label;
            this.pop(el);
          });
          this.positionBand();
          this.updateApply();
          this.animateTo(this.target());
        }

        setActive(key) {
          if (key === this.active) return;
          this.active = key;
          this.classList.toggle('has-active', !!key);
          this.querySelectorAll('[data-key]').forEach((el) => {
            el.classList.toggle('is-active', el.dataset.key === key);
          });
        }

        positionBand() {
          const wrap = this.querySelector('.bdsg__table-wrap');
          const band = this.querySelector('.bdsg__band');
          const row = this.querySelector('[data-row="' + this.size + '"]');
          if (!wrap || !band || !row) return;
          const wr = wrap.getBoundingClientRect();
          const r = row.getBoundingClientRect();
          if (!r.height) return;
          band.style.height = r.height + 'px';
          band.style.transform = 'translateY(' + (r.top - wr.top) + 'px)';
          if (!this.classList.contains('is-placed')) {
            requestAnimationFrame(() => this.classList.add('is-placed'));
          }
        }

        pop(el) {
          if (this.reduced || !el) return;
          el.classList.remove('is-pop');
          void el.offsetWidth;
          el.classList.add('is-pop');
        }

        updateApply() {
          const btn = this.querySelector('[data-apply]');
          if (!btn) return;
          const value = this.values[this.size];
          btn.hidden = !value;
          const done = this.size === this.selected;
          const text = done ? this.dataset.appliedLabel : this.dataset.applyLabel;
          btn.textContent = (text || '').replace('[size]', this.labels[this.size]);
          btn.classList.toggle('is-done', done);
        }

        pickOption(name, value) {
          if (!name || !value) return false;
          const scope = this.section || document;
          const target = String(value).toLowerCase();
          const radios = scope.querySelectorAll('variant-picker input[type="radio"]');
          for (const radio of radios) {
            if (radio.name.indexOf(name + '-') === 0 && radio.value.toLowerCase() === target) {
              if (!radio.checked) radio.click();
              return true;
            }
          }
          const selects = scope.querySelectorAll('variant-picker select');
          for (const select of selects) {
            if (select.name !== 'options[' + name + ']') continue;
            const option = Array.from(select.options).find((o) => o.value.toLowerCase() === target);
            if (!option) continue;
            if (select.value !== option.value) {
              select.value = option.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            }
            return true;
          }
          return false;
        }

        applyToProduct() {
          if (this.size === this.selected) return;
          if (this.pickOption(this.dataset.option, this.values[this.size])) {
            this.selected = this.size;
            this.updateApply();
          }
        }

        syncFromVariant(e) {
          const resource = e.detail && e.detail.resource;
          if (!resource) return;
          const options = resource.options || [resource.option1, resource.option2, resource.option3];
          const values = this.values.map((v) => v.toLowerCase());
          options.forEach((raw) => {
            const i = values.indexOf(String(raw || '').toLowerCase());
            if (i > -1) {
              this.selected = i;
              this.setSize(i);
              this.updateApply();
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lmds-pyjama-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lmds-pyjama-size-guide')) {
    customElements.define(
      'lmds-pyjama-size-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.cut = this.dataset.cut || 'winter';
          this.size = parseInt(this.dataset.size, 10) || 0;
          this.sizes = (this.dataset.sizes || '').split('|');
          this.frs = (this.dataset.frs || '').split('|');
          this.ease = parseFloat(this.dataset.ease) || 8;
          this.touched = false;
          this.drawn = false;
          this.active = null;
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.classList.add('pjsg--reset', 'is-ready');
          void this.offsetWidth;
          this.classList.remove('pjsg--reset');

          this.querySelectorAll('[data-cut-btn]').forEach((btn) => {
            btn.addEventListener('click', () => this.setCut(btn.dataset.cutBtn));
          });

          this.addEventListener('click', (e) => {
            const sizeBtn = e.target.closest('[data-size-index]');
            if (sizeBtn) this.setSize(parseInt(sizeBtn.dataset.sizeIndex, 10));
            const keyed = e.target.closest('[data-key]');
            if (keyed) this.setActive(keyed.dataset.key);
          });

          this.addEventListener('pointerover', (e) => {
            if (e.pointerType !== 'mouse') return;
            const el = e.target.closest('[data-key]');
            this.setActive(el ? el.dataset.key : null);
          });
          this.addEventListener('pointerleave', (e) => {
            if (e.pointerType === 'mouse') this.setActive(null);
          });
          this.addEventListener('focusin', (e) => {
            const el = e.target.closest('[data-key]');
            if (el) this.setActive(el.dataset.key);
          });
          this.addEventListener('focusout', () => this.setActive(null));

          this.querySelectorAll('[data-range]').forEach((input) => {
            this.paintRange(input);
            input.addEventListener('input', () => {
              this.touched = true;
              this.paintRange(input);
              this.updateFinder(true);
            });
          });

          const apply = this.querySelector('[data-apply]');
          if (apply) apply.addEventListener('click', () => this.applyToProduct());

          this.section = this.closest('.shopify-section');
          this.onVariant = (e) => this.syncFromVariant(e);
          if (this.section) this.section.addEventListener('variant:update', this.onVariant);

          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.positionBand();
                if (!this.drawn) this.draw();
              } else {
                const details = this.closest('details');
                if (details && !details.open) {
                  this.drawn = false;
                  this.classList.remove('is-drawn');
                  this.classList.remove('is-placed');
                }
              }
            });
          });
          this.io.observe(this);

          this.ro = new ResizeObserver(() => this.positionBand());
          this.ro.observe(this);

          this.updateFinder(false);
        }

        disconnectedCallback() {
          if (this.section) this.section.removeEventListener('variant:update', this.onVariant);
          if (this.io) this.io.disconnect();
          if (this.ro) this.ro.disconnect();
        }

        panel() {
          return this.querySelector('[data-panel="' + this.cut + '"]');
        }

        draw() {
          this.drawn = true;
          if (this.reduced) {
            this.classList.add('is-drawn');
            return;
          }
          this.classList.add('pjsg--reset');
          this.classList.remove('is-drawn');
          void this.offsetWidth;
          this.classList.remove('pjsg--reset');
          requestAnimationFrame(() => this.classList.add('is-drawn'));
        }

        setCut(cut) {
          if (cut !== 'summer' && cut !== 'winter') return;
          if (cut === this.cut) return;
          this.cut = cut;
          this.dataset.cut = cut;
          this.querySelectorAll('[data-cut-btn]').forEach((btn) => {
            btn.setAttribute('aria-pressed', btn.dataset.cutBtn === cut ? 'true' : 'false');
          });
          this.querySelectorAll('[data-panel]').forEach((p) => {
            p.hidden = p.dataset.panel !== cut;
          });
          this.setActive(null);
          this.classList.remove('is-placed');
          this.positionBand();
          this.updateFinder(false);
          if (this.drawn) this.draw();
        }

        setSize(index) {
          if (isNaN(index) || index < 0 || index >= this.sizes.length) return;
          this.size = index;
          this.dataset.size = index;
          this.querySelectorAll('[data-size-index]').forEach((btn) => {
            btn.setAttribute('aria-pressed', parseInt(btn.dataset.sizeIndex, 10) === index ? 'true' : 'false');
          });
          this.querySelectorAll('td[data-col]').forEach((td) => {
            td.classList.toggle('is-sel', parseInt(td.dataset.col, 10) === index);
          });
          const fr = this.frs[index];
          const prefix = this.dataset.frPrefix || '';
          const label = (this.dataset.sizeWord || '') + ' ' + this.sizes[index] + (fr ? ' · ' + prefix + ' ' + fr : '');
          this.querySelectorAll('[data-stage-size]').forEach((el) => {
            if (el.textContent === label) return;
            el.textContent = label;
            this.pop(el);
          });
          this.positionBand();
        }

        setActive(key) {
          if (key === this.active) return;
          this.active = key;
          this.classList.toggle('has-active', !!key);
          this.querySelectorAll('[data-key]').forEach((el) => {
            el.classList.toggle('is-active', el.dataset.key === key);
          });
        }

        positionBand() {
          const panel = this.panel();
          if (!panel) return;
          const wrap = panel.querySelector('.pjsg__table-wrap');
          const band = panel.querySelector('.pjsg__band');
          const ths = panel.querySelectorAll('thead th');
          const th = ths[this.size + 1];
          if (!wrap || !band || !th) return;
          const wr = wrap.getBoundingClientRect();
          const r = th.getBoundingClientRect();
          if (!r.width) return;
          band.style.width = r.width + 'px';
          band.style.transform = 'translateX(' + (r.left - wr.left + wrap.scrollLeft) + 'px)';
          if (!this.classList.contains('is-placed')) {
            requestAnimationFrame(() => this.classList.add('is-placed'));
          }
        }

        pop(el) {
          if (this.reduced || !el) return;
          el.classList.remove('is-pop');
          void el.offsetWidth;
          el.classList.add('is-pop');
        }

        paintRange(input) {
          const min = parseFloat(input.min);
          const max = parseFloat(input.max);
          const val = parseFloat(input.value);
          input.style.setProperty('--p', ((val - min) / (max - min)) * 100 + '%');
          const out = input.closest('.pjsg__field').querySelector('[data-out]');
          if (out) out.textContent = val + ' cm';
        }

        numbers(list) {
          return (list || '')
            .split('|')
            .map((v) => parseFloat(v))
            .filter((n) => !isNaN(n));
        }

        updateFinder(fromInput) {
          const panel = this.panel();
          const result = this.querySelector('.pjsg__result');
          if (!panel || !result) return;
          const bust = this.numbers(panel.dataset.bust);
          const hip = this.numbers(panel.dataset.hip);
          const useHip = hip.length === bust.length && hip.length > 0;
          const hipField = this.querySelector('[data-hip-field]');
          if (hipField) hipField.hidden = !useHip;
          if (!this.touched) return;

          const b = parseFloat(this.querySelector('[data-range="bust"]').value);
          const hipInput = this.querySelector('[data-range="hip"]');
          const h = hipInput ? parseFloat(hipInput.value) : 0;
          let index = -1;
          for (let i = 0; i < bust.length; i++) {
            if (b <= bust[i] - this.ease && (!useHip || h <= hip[i] - this.ease)) {
              index = i;
              break;
            }
          }

          const apply = this.querySelector('[data-apply]');
          if (index === -1) {
            result.dataset.state = 'over';
            this.recommended = -1;
            return;
          }

          const changed = this.recommended !== index || result.dataset.state !== 'ok';
          this.recommended = index;
          result.dataset.state = 'ok';
          const sizeEl = this.querySelector('[data-result-size]');
          const frEl = this.querySelector('[data-result-fr]');
          sizeEl.textContent = this.sizes[index];
          frEl.textContent = this.frs[index] ? (this.dataset.frPrefix || '') + ' ' + this.frs[index] : '';
          if (apply) {
            apply.classList.remove('is-done');
            apply.textContent = (this.dataset.applyLabel || '').replace('[size]', this.sizes[index]);
          }
          if (changed) this.pop(sizeEl);
          if (fromInput) this.setSize(index);
        }

        pickOption(name, value) {
          if (!name || !value) return false;
          const scope = this.section || document;
          const target = String(value).toLowerCase();
          const radios = scope.querySelectorAll('variant-picker input[type="radio"]');
          for (const radio of radios) {
            if (radio.name.indexOf(name + '-') === 0 && radio.value.toLowerCase() === target) {
              if (radio.checked) return 'same';
              radio.click();
              return 'changed';
            }
          }
          const selects = scope.querySelectorAll('variant-picker select');
          for (const select of selects) {
            if (select.name !== 'options[' + name + ']') continue;
            const option = Array.from(select.options).find((o) => o.value.toLowerCase() === target);
            if (!option) continue;
            if (select.value === option.value) return 'same';
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return 'changed';
          }
          return false;
        }

        waitForVariant() {
          return new Promise((resolve) => {
            const scope = this.section || document;
            const done = () => {
              clearTimeout(timer);
              scope.removeEventListener('variant:update', done);
              setTimeout(resolve, 60);
            };
            const timer = setTimeout(done, 3000);
            scope.addEventListener('variant:update', done);
          });
        }

        async applyToProduct() {
          if (this.recommended === undefined || this.recommended < 0 || this.applying) return;
          this.applying = true;
          const index = this.recommended;
          const cutValue = this.cut === 'summer' ? this.dataset.summerValue : this.dataset.winterValue;
          const pending = this.waitForVariant();
          if (this.pickOption(this.dataset.cutOption, cutValue) === 'changed') await pending;
          const ok = this.pickOption(this.dataset.sizeOption, this.sizes[index]);
          this.applying = false;
          const apply = this.querySelector('[data-apply]');
          if (ok && apply) {
            apply.textContent = (this.dataset.appliedLabel || '').replace('[size]', this.sizes[index]);
            apply.classList.add('is-done');
          }
        }

        syncFromVariant(e) {
          const resource = e.detail && e.detail.resource;
          if (!resource) return;
          const options = resource.options || [resource.option1, resource.option2, resource.option3];
          const summer = (this.dataset.summerValue || '').toLowerCase();
          const winter = (this.dataset.winterValue || '').toLowerCase();
          const sizes = this.sizes.map((s) => s.toLowerCase());
          options.forEach((raw) => {
            const v = String(raw || '').toLowerCase();
            if (summer && v === summer) this.setCut('summer');
            else if (winter && v === winter) this.setCut('winter');
            const i = sizes.indexOf(v);
            if (i > -1) this.setSize(i);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["lmds-scrunchie-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lmds-scrunchie-guide')) {
    customElements.define(
      'lmds-scrunchie-guide',
      class extends HTMLElement {
        connectedCallback() {
          this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.classList.add('scsg--reset', 'is-ready');
          void this.offsetWidth;
          this.classList.remove('scsg--reset');
          this.cards = Array.from(this.querySelectorAll('.scsg__card'));
          this.cards.forEach((card) => {
            card.addEventListener('click', () => this.choose(card));
          });
          this.section = this.closest('.shopify-section');
          this.onVariant = (e) => this.sync(e);
          if (this.section) this.section.addEventListener('variant:update', this.onVariant);
          this.io = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (!this.drawn) this.draw();
              } else {
                const details = this.closest('details');
                if (details && !details.open) {
                  this.drawn = false;
                  this.classList.remove('is-drawn');
                }
              }
            });
          });
          this.io.observe(this);
        }

        disconnectedCallback() {
          if (this.section) this.section.removeEventListener('variant:update', this.onVariant);
          if (this.io) this.io.disconnect();
        }

        draw() {
          this.drawn = true;
          if (this.reduced) {
            this.classList.add('is-drawn');
            return;
          }
          this.classList.add('scsg--reset');
          this.classList.remove('is-drawn');
          void this.offsetWidth;
          this.classList.remove('scsg--reset');
          requestAnimationFrame(() => this.classList.add('is-drawn'));
        }

        mark(value) {
          const target = String(value || '').toLowerCase().replace(/\s/g, '');
          this.cards.forEach((card) => {
            const match = card.dataset.value.toLowerCase().replace(/\s/g, '') === target;
            card.setAttribute('aria-pressed', match ? 'true' : 'false');
          });
        }

        choose(card) {
          this.mark(card.dataset.value);
          const name = this.dataset.option;
          if (!name) return;
          const scope = this.section || document;
          const target = card.dataset.value.toLowerCase();
          const radio = Array.from(scope.querySelectorAll('variant-picker input[type="radio"]')).find(
            (r) => r.name.indexOf(name + '-') === 0 && r.value.toLowerCase() === target
          );
          if (radio) {
            if (!radio.checked) radio.click();
            return;
          }
          const select = Array.from(scope.querySelectorAll('variant-picker select')).find(
            (s) => s.name === 'options[' + name + ']'
          );
          if (!select) return;
          const option = Array.from(select.options).find((o) => o.value.toLowerCase() === target);
          if (option && select.value !== option.value) {
            select.value = option.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        sync(e) {
          const resource = e.detail && e.detail.resource;
          if (!resource) return;
          const options = resource.options || [resource.option1, resource.option2, resource.option3];
          const values = this.cards.map((c) => c.dataset.value.toLowerCase().replace(/\s/g, ''));
          options.forEach((raw) => {
            const v = String(raw || '').toLowerCase().replace(/\s/g, '');
            if (values.indexOf(v) > -1) this.mark(v);
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
